import { useMemo } from 'react'
import { DATE_RANGE_TEMPLATES_HANDLER } from './helpers'
import { parse, parseISO, isValid } from 'date-fns'

function toDate(date) {
  if (date === undefined || date === null) {
    return date
  }

  let d

  if (date instanceof Date) {
    d = date
  } else if (typeof date === 'number') {
    d = new Date(date)
  } else if (typeof date === 'string' && date.length) {
    d = date.includes('/')
      ? parse(date, 'MM/dd/yyyy', new Date())
      : parseISO(date)
  } else {
    return null
  }

  if (!isValid(d)) {
    return null
  }

  return d
}

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    let from = toDate(props.daterange?.from)
    let to = toDate(props.daterange?.to)

    let date_range = {
      ...props.daterange,
      from,
      to,
    }

    return {
      ...data,
      date_range,
      templates:
        Array.isArray(props.templates) && props.templates.length > 0
          ? [
              {
                id: 'CUSTOM',
                text: 'Custom',
              },
              ...props.templates.map(template =>
                data.templates.find(item => item.id === template)
              ),
            ]
              .filter(Boolean)
              .map(template => ({
                ...template,
                ...DATE_RANGE_TEMPLATES_HANDLER[template.id],
              }))
          : data.mainTemplates,
    }
  }, [props.daterange, props.templates, data])
}
